const CLEAR_ELIGIBILITY_RESULTS = 'CLEAR_ELIGIBILITY_RESULTS';
const SET_ELIGIBILITY_RESULTS = 'SET_ELIGIBILITY_RESULTS';

export const ELIGIBILITY_RESULTS_ACTION_TYPES = {
    SET_ELIGIBILITY_RESULTS,
    CLEAR_ELIGIBILITY_RESULTS
};